import ManageWarehouseForm from '@/PageComponents/Warehouse/ManageWarehouseForm';
import warehouseService from '@/services/warehouse/warehouse-service';
import helper from '@/utils/helper';
import { Card, Container } from '@mantine/core';
import { useQuery } from '@tanstack/react-query';
import { useRouter } from 'next/router';
import { FC } from 'react';
import { createFileRoute } from '@tanstack/react-router'

const VanEditPage: FC = () => {

    const router = useRouter();
    const { id } = router.query as { id: string }; // TODO(tanstack-router): verify router.query → useParams/useSearch

    const { data: van, isLoading, error } = useQuery(['van', id], () => warehouseService.getWarehouse(id), {
        enabled: !!id,
    });

    if (isLoading || !van) return <div>Loading...</div>;

    return (<>
        <Container size={"xl"} p="md">
            <Card shadow="sm" padding="lg" radius="md" withBorder flex={2} pos={'relative'}>
                <ManageWarehouseForm
                    isNew={false}
                    caller='pages/van/[id]/edit'
                    warehouse={van}
                    onBack={() => {
                        helper.nextRouter(router.push, '/van/[id]', '/van/' + id);
                    }}
                />
            </Card>
        </Container>
        <style jsx>{`
            
        `}</style>
    </>);
};

export default VanEditPage;

export const Route = createFileRoute('/_authenticated/van/$id/edit')({ component: VanEditPage })
